import { render, staticRenderFns } from "./patient-summary-side-bar.vue?vue&type=template&id=621e9344&scoped=true&"
import script from "./patient-summary-side-bar.vue?vue&type=script&lang=js&"
export * from "./patient-summary-side-bar.vue?vue&type=script&lang=js&"
import style0 from "./patient-summary-side-bar.vue?vue&type=style&index=0&id=621e9344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621e9344",
  null
  
)

export default component.exports